import { render } from "./dropZoneMultiple.vue?vue&type=template&id=91c873b6&scoped=true"
import script from "./dropZoneMultiple.vue?vue&type=script&lang=js"
export * from "./dropZoneMultiple.vue?vue&type=script&lang=js"

import "./dropZoneMultiple.vue?vue&type=style&index=0&id=91c873b6&scoped=true&lang=scss"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91c873b6"]])

export default __exports__